import React from 'react';
import NoSSR from 'react-no-ssr';
import ChipEdit from 'ChipEdit';
import transform from '../../../common/transform';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Header from './header';
import Content from './content';
import BottomFooter from './bottomFooter';
import Affix from './affix';

class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    componentDidMount() {
        // 上报首屏时间
        if (window && window.BJ_REPORT) window.BJ_REPORT.firstScreen();
    }

    render() {
        const { content } = this.props;
        const {
            docData,
            docData: {
                noAd,
                base62Id,
                title,
                pcUrl,
                url,
                summery,
                newsTime,
                updateTime,
                searchPath,
                fhhAccountDetail,
                source,
                sourceUrl,
                imagesInContent,
                skey,
                commentUrl,
                subscribe,
                seoAbValue,
                seoTitle,
                seoDescription,
                quanPlugin,
            },
            sectionData: { sectionTitle, logo, sectionUrl },
            search,
            topAd,
            bottomAd,
            footer,
            rightAd,
            hasCopyRight,
            sourceReason,
        } = content;

        const headerData = {
            search,
            topAd,
            sectionTitle,
            logo,
            sectionUrl,
        };
        const contentData = {
            captionData: {
                noAd,
                base62Id,
                title,
                pcUrl,
                url,
                newsTime,
                updateTime,
                fhhAccountDetail,
                source,
                sourceUrl,
                skey,
                commentUrl,
                subscribe,
                seoAbValue,
                seoTitle,
                seoDescription,
                quanPlugin,
            },
            leftContentData: {
                article: docData,
                hasCopyRight,
                sourceReason,
            },
            rightContentData: {
                base62Id,
                searchPath,
                rightAd,
            },
        };
        const footerData = { bottomAd, footer };
        const affixData = {
            title,
            summery,
            imagesInContent,
            pcUrl,
        };

        return (
            <div>
                <Header content={headerData} />
                <Content content={contentData} />
                <BottomFooter content={footerData} />
                <NoSSR>
                    <Affix content={affixData} />
                </NoSSR>
                <ChipEdit transform={transform} />
            </div>
        );
    }
}

export default errorBoundary(Layout);
